import { List } from 'immutable';
import map from 'transmute/map';
import { buildThreadRemoval } from './buildThreadRemoval';
export const buildThreadRemovals = removals => {
  return List(map(buildThreadRemoval, removals));
};